import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaObservacao = (): TabelaColuna => ({
  Chave: 'observacao',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 250 }}>Observacao</div>
})
